// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scroll[data-v-f51c8000] {\n    overflow-y: scroll\n}\n", ""]);
// Exports
module.exports = exports;
